// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2Y3jm","additionalInfo":"AgreementModal_additionalInfo__1tK_O"};